import React from 'react'
import { ToastContainer } from 'react-toastify'

import './styles/recurring-repair.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import RecurringRepair from './components/RecurringRepair'

type Props = {}

export default function App({}: Props) {
    const queryClient = new QueryClient();
    const params = new URLSearchParams(window.location.search);
    const subscriptionId = params.get('id');

  return (
    <QueryClientProvider client={queryClient}>
      <div>
          <RecurringRepair subscriptionId={subscriptionId} />
      </div>
      <ToastContainer />
    </QueryClientProvider>
  )
}